import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import { CourseHighlights } from '../../../../components/CourseHighlights';
import { PublicCourse, PublicOccurrence } from '@cademy-package/sdk-component-types';
import classNames from 'classnames';

export type HighlightsSectionProps = {
    course: PublicCourse;
    occurrences: PublicOccurrence[] | null;
    className?: string;
};

export const HighlightsSection: FunctionComponent<HighlightsSectionProps> = ({
    course,
    occurrences,
    className,
}) => {
    return (
        <section
            className={classNames(styles.highlights_section, className)}
            aria-labelledby="highlights-header"
        >
            <h2 id="highlights-header">Highlights</h2>
            <CourseHighlights course={course} occurrences={occurrences} />
        </section>
    );
};

export default HighlightsSection;
